import {
  Swiper, EffectFade, Navigation, Lazy,
} from 'swiper';
import SimpleBar from 'simplebar';

window.addEventListener('load', () => {
  function refreshTabindex() {
    const disabledLinks = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-active) a');
    disabledLinks.forEach((link) => {
      link.tabIndex = -1;
    });

    const activeLinks = this.el.querySelectorAll('.swiper-slide-active a');
    activeLinks.forEach((link) => {
      link.tabIndex = 0;
    });
  }

  new Swiper('.full-width-image-and-text__swiper.swiper', {
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    preloadImages: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      prevEl: '.full-width-image-and-text__button-prev',
      nextEl: '.full-width-image-and-text__button-next',
    },
    modules: [EffectFade, Navigation, Lazy],
    lazy: {
      preloaderClass: 'c-slide-preloader',
      loadPrevNext: true,
    },
    on: {
      init() {
        refreshTabindex.call(this);
      },
      slideChangeTransitionEnd() {
        refreshTabindex.call(this);
      },
    },
  });

  const postSlideContent  = document.querySelector('.post .full-width-image-and-text .full-width-image-and-text__content');

  if (postSlideContent !== null) {
      new SimpleBar(postSlideContent);
  }
});
